import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import type { BotStripeAccountStatusWebSocket } from "@/Modules/Chat/Models/WebSocket";

import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { useTherapistStore, type TherapistStore } from "@/Modules/Therapist/Store";

import { isObject } from "@/Utils/Objects";

export interface ExtraParamsBotStripeAccountStatus {
  therapistStore: TherapistStore;
}

export const isBotStripeAccountStatus = (value: unknown): value is BotStripeAccountStatusWebSocket => {
  return isObject(value) && value.type === MessageTypeWebSocket.STRIPE_ACCOUNT_STATUS_CHANGED;
};

export const botStripeAccountStatusHandler = async (
  _message: unknown,
  { therapistStore = useTherapistStore() }: ExtraParamsBotStripeAccountStatus
): Promise<undefined> => {
  await therapistStore.setTherapist();

  return Promise.resolve(undefined);
};

export default {
  isType: isBotStripeAccountStatus,
  handler: botStripeAccountStatusHandler,
} as EventFilter<ExtraParamsBotStripeAccountStatus>;
